import { useMutation } from "react-query";
import useApi from "./useApiRequest";

export const ReporteGeneralExistencias = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.post(`/existencias/general`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        reporteGeneralExistenciasMutation: mutation.mutate,
    };
}

export const ReporteSegundoExistencias = ()  => {
    const api = useApi();

    const mutate = async (params) => {
      console.log(params)
        const data  = await api.post(`/existencias/segundo-nivel`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        reporteSegundoExistenciasMutation: mutation.mutate,
    };
}

export const ReporteTerceroExistencias = ()  => {
    const api = useApi();

    const mutate = async (params) => {
      console.log(params)
        const data  = await api.post(`/existencias/tercer-nivel`, params, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        reporteTerceroExistenciasMutation: mutation.mutate,
    };
}